// extracted by mini-css-extract-plugin
export default {"defaultButtonWrapper":"collapsibleSection_defaultButtonWrapper__U8TOR"};